import jwt from "jwt-decode";
import cartIcon from '../media/images/cart.svg';
import {Box, SwipeableDrawer, IconButton, Typography} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import './Cart.css'
import {useCabanaContext} from "./CabanaContext";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import React from "react";
import {Link} from "react-router-dom";
import {useAnalytics} from "../hook/useAnalytics";
import {countriesCurrencies} from "../services/CheckUtils";

export default function Cart() {
    const { trackEvent } = useAnalytics();
    const { cart, removeFromCart, isCartOpen, closeCart, openCart, updateGiftQuantity, listCode, wishlist} = useCabanaContext();
    // Retrieve token from localStorage or sessionStorage
    const jwtToken = localStorage.getItem('token') || sessionStorage.getItem('token');
    // Check if the token exists and can be decoded
    let decodedUser: any = null;
    try {
        if (jwtToken) {
            decodedUser = jwt(jwtToken);
        }
    } catch (error) {
        console.error("Errore nel decoding del token:", error);
        decodedUser = null; // If the token is invalid, we treat it as null
    }

    // If token does not exist or role is not 3, do not show cart
    if (!decodedUser || decodedUser.role !== 3) {
        return null;
    }

    const pageName = window.location.pathname.split('/')[2];
    if(pageName === 'checkout' || pageName === 'purchase-success' || pageName === 'purchase-error'){
        return null
    }
    const calculateSubtotal = () => {
        return cart.reduce((total, product) => {
            const productPrice = parseFloat(product.variations[0].price_value); // Assuming we use the first variation
            return total + productPrice * product.gift_quantity; // Calculate the subtotal for each product
        }, 0);
    };

    const formattedSubtotal = () => {
        return new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: wishlist.currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(calculateSubtotal());
    }

    return(
        <>
            <Box
                className={"cart-container"}
                onClick={() => openCart()}
            >
                <img
                    srcSet={cartIcon}
                    src={cartIcon}
                    alt={cartIcon}
                    loading="lazy"
                    className={"cart-icon"}
                />
                <span className={"cart-counter"}>
                        {(cart.length === 0) ? '' : cart.length}
                    </span>
            </Box>

            <SwipeableDrawer
                anchor={'right'}
                open={isCartOpen}
                variant="temporary"
                onClose={() => closeCart()}
                onOpen={() => {}}
            >
                <Box className={'cart-drawer'}>
                    <Box className={'cart-title'}>
                        ADD TO LIST
                    </Box>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeCart()}
                        sx={{ position: 'absolute', right: 8, top: 8, color: 'black'}}
                    >
                        <CloseIcon />
                    </IconButton>
                    {cart.length === 0 ? (
                        <Typography className={'cart-empty-text'} variant="body1">Your cart is currently empty.</Typography>
                    ) : (
                        <Box className={'container-cart-products'}>
                            {cart.map(product => {
                                const price = new Intl.NumberFormat('it-IT', {
                                    style: 'currency',
                                    currency: product.variations[0].price_currency,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }).format(parseFloat(product.variations[0].price_value));
                                return(
                                    <Box key={product.id} className="cart-item">
                                        <Box className={'img-product-container'}>
                                            <img
                                                src={product.image_url}
                                                alt={'product-cart-image'}
                                            />
                                        </Box>
                                        <Box className={'container-info'}>
                                            <Box>
                                                <Typography className={'title'}>{product.title.toUpperCase()}</Typography>
                                                <Typography className={'subtitle'}>{product.subtitle.toUpperCase()}</Typography>
                                                <Typography className={'unity-price'}>
                                                    {price}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Box className="quantity-selector">
                                                    <IconButton
                                                        onClick={() => updateGiftQuantity(product.id, product.gift_quantity - 1)}
                                                        disabled={product.gift_quantity <= 1}
                                                        size="small"
                                                        sx={{
                                                            padding: "0",
                                                            color: "black",
                                                            cursor: "pointer!important",
                                                            width: "17px",
                                                            height: "17px"
                                                        }}
                                                    >
                                                        <RemoveIcon />
                                                    </IconButton>

                                                    <Typography className={'quantity-value'}>{product.gift_quantity}</Typography>

                                                    <IconButton
                                                        onClick={() => updateGiftQuantity(product.id, product.gift_quantity + 1)}
                                                        disabled={product.gift_quantity >= product.quantity_selected - product.quantity_purchased}
                                                        size="small"
                                                        sx={{
                                                            padding: "0",
                                                            color: "black",
                                                            cursor: "pointer!important",
                                                            width: "17px",
                                                            height: "17px"
                                                        }}
                                                    >
                                                        <AddIcon />
                                                    </IconButton>
                                                </Box>
                                                <Typography
                                                    className={'remove-product-cart'}
                                                    onClick={() => removeFromCart(product.id)}
                                                >
                                                    Remove
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                )
                            })}

                            <Box className="cart-subtotal">
                                <Box className={'info'}>
                                    <Typography className={'text'}>
                                        Subtotal:
                                    </Typography>
                                    <Typography className={'value'}>
                                        {formattedSubtotal()}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    {
                        (cart.length > 0) ?
                            <Box className="cart-checkout">
                                <Link
                                    to={`/gifter/finalize-gift?listCode=${cart[0].list_code}`}
                                    className={`cart-checkout-button`}
                                    onClick={() => {
                                        trackEvent("start_checkout_from_registry", {
                                            category: "cabana_event",
                                            label: "A user starts checkout directly from the gift list",
                                            registry_id: cart[0].list_code,
                                            total_value: formattedSubtotal(),
                                            product_count: cart.length
                                        });
                                        closeCart()
                                    }}
                                >
                                    CHECKOUT
                                </Link>
                            </Box>
                            :
                            <></>
                    }
                </Box>
            </SwipeableDrawer>
        </>
    )
}